import React from 'react';
import { Dispatch } from 'redux';
import modalActions from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import {
  NETWORK_ERROR_MODAL_TEXT,
  NETWORK_ERROR_MODAL_TITLE,
} from '@mm/constants/error-descriptions';
import CrudActionContainer from '../actions/CrudActionContainer';

export type ResponseOrError = Response | TypeError | Error;

export const integrationsHandler = (
  dispatch: Dispatch<StoreState>,
  container: CrudActionContainer,
) => {
  return (errorText?: string) => {
    dispatch(container.unbusy());
    dispatch(
      modalActions.openPrettyErrorModal({
        errorMessage: NETWORK_ERROR_MODAL_TEXT,
        title: NETWORK_ERROR_MODAL_TITLE,
        detailsForNerds: errorText,
      }),
    );

    return { error: true, errorText };
  };
};
